import { render, staticRenderFns } from "./ViewVisitSheet.vue?vue&type=template&id=497f219c"
import script from "./ViewVisitSheet.vue?vue&type=script&lang=js"
export * from "./ViewVisitSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports